import type { LauncherPolicy, ModEntry, DiscordLink } from '@mcpanel/core';
import { rawRequest } from './client';
const path = (id: string) => '/servers/' + encodeURIComponent(id);
export const launcherApi = {
  policy: (id: string) => rawRequest<LauncherPolicy>('GET', path(id) + '/launcher-policy'),
  savePolicy: (id: string, policy: LauncherPolicy) =>
    rawRequest<LauncherPolicy>('PUT', path(id) + '/launcher-policy', policy),
  side: (id: string, mod: ModEntry, clientSide: ModEntry['clientOverride'] | null) =>
    rawRequest<ModEntry>('PATCH', path(id) + '/mods/side', {
      source: mod.source,
      projectId: mod.projectId,
      clientSide,
    }),
  links: () => rawRequest<DiscordLink[]>('GET', '/discord-links'),
  unlink: (uuid: string) => rawRequest<void>('DELETE', '/discord-links/' + encodeURIComponent(uuid)),
};
